import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-waiting-payment',
  templateUrl: './waiting-payment.component.html',
  styleUrls: ['./waiting-payment.component.css']
})
export class WaitingPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
